import { isValidPhoneNumber } from 'react-phone-number-input/max';
import { validation } from './sign-up.types';
import { REGEXES } from './sign-up.constants';

export const validateNotEmail: validation = (text: string): boolean => !REGEXES.EMAIL.test(text);

export const validateEmail: validation = (text: string): boolean => REGEXES.EMAIL.test(text);

export const validateContainsLetter: validation = (text: string): boolean => REGEXES.CONTAINS_LETTER
    .test(text);

export const validateNotURL: validation = (text: string): boolean => !REGEXES.URL.test(text);

export const validateFullName: validation = (text: string): boolean => REGEXES.FULL_NAME.test(text);

export const validatePhoneNumber: validation = (text: string): boolean => isValidPhoneNumber(text);
